// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"85":"5a5e70be","458":"5c86d85d","658":"bbffc31c","743":"b49332e1","807":"d06283f5"}[chunkId] + ".css";
};